import React from 'react';
import { timeAgo } from '@/utils/ts/stringUtils';
import AccessAlarmIcon from '@mui/icons-material/AccessAlarm';
import { NotificationManager } from 'react-notifications';
import { useDispatch } from 'react-redux';

import { fetchNotifications } from '../../../redux/notifications/notificationActions';
import { completeTask } from '../../../services/tasks.service';
import AvatarComponent from '../AvatarComponent/AvatarComponent';

export default function TaskNotification({ notification, handleNavigate }) {
  const dispatch = useDispatch();

  const handleCompleteTask = async (e, id) => {
    e.stopPropagation();
    const response = await completeTask(id);
    if (response?.status) {
      NotificationManager.success('Task marked as complete!', '', 1200);
      dispatch(fetchNotifications());
    } else {
      NotificationManager.error('Error while marking task as complete', '', 1200);
    }
  };

  return (
    <div
      className={`single-notification ${notification.seen && 'seen'}`}
      onClick={handleNavigate}
      style={{ cursor: 'pointer' }}>
      <div className="unread-dot"></div>
      <div className="avatar-div">
        <AvatarComponent
          src={notification?.influencerId?.profile_pic}
          alt={notification?.influencerId?.name || notification?.influencerId?.user_name}
        />
      </div>
      <div className="text-div">
        <h3 className="title">
          {`Task Reminder for ${notification?.influencerId?.name || '@' + notification?.influencerId?.user_name}`}{' '}
        </h3>
        {notification.type === 'task' && (
          <>
            <p className="description">
              <AccessAlarmIcon />
              {notification?.content?.message}
            </p>
            <div className="btn-container">
              {notification?.content?.isCompleted ? (
                <p className="completed" style={{ padding: '8px 0 5px 0' }}>
                  Completed
                </p>
              ) : (
                <button
                  className="complete-btn"
                  type="button"
                  onClick={(e) => handleCompleteTask(e, notification?.content?.taskId)}>
                  Mark as complete
                </button>
              )}
            </div>
          </>
        )}
        <p className="timestamp">{timeAgo(notification?.createdAt)}</p>
      </div>
    </div>
  );
}
